import m from "../../../../geodata/es2015/region/world/oceaniaHigh";
window.am4geodata_region_world_oceaniaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/oceaniaHigh.js
// module id = null
// module chunks = 